// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 594 ? "about" : chunkId) + "." + {"171":"b383baea","594":"e0c8024e","686":"77223675","715":"78f84f87"}[chunkId] + ".css";
};